var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.88,
    height: 18.507,
    viewBox: "0 0 13.88 18.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin_2_",
    "data-name": "pin (2)",
    transform: "translate(-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M70.94,0A6.948,6.948,0,0,0,64,6.94c0,5.12,6.4,11.206,6.676,11.462a.386.386,0,0,0,.529,0c.273-.257,6.676-6.342,6.676-11.462A6.948,6.948,0,0,0,70.94,0Zm0,10.8A3.856,3.856,0,1,1,74.8,6.94,3.86,3.86,0,0,1,70.94,10.8Z",
    transform: "translate(-64)",
    fill: "#525252"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.c04e6f9f1a6a8a13c57777f9efe0c2d3.svg";
export { ForwardRef as ReactComponent };